import { Events } from "@Context/common/general/context";
import AccountAuthorizations from "@Enums/AccountAuthorizations";
import useAuthorizations from "@hooks/common/general/use-authorizations";
import useGlobalContext from "@hooks/common/general/use-global-context";
import useI18n from "@i18n";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import HeaderTab from "../header-tab";
import HeaderTabBar from "../header-tab-bar";

const routeObjects: { [key: string]: { label: string; path: string } } = {
  "/home": { label: "header.tab.home", path: "/home" },
  "/progress": { label: "header.tab.progress", path: "/progress" },
  "/activity": { label: "header.tab.activity", path: "/activity" },
  "/playlists": { label: "header.tab.playlists", path: "/playlists" },
  "/coach": { label: "header.tab.coach", path: "/coach" },
};

const routeObjectList = Object.values(routeObjects);

export interface IHeaderCenterSection {
  currentTab?: number;
  onTabChange?: (event: React.SyntheticEvent, newTabIndex: number) => void;
  showTabs?: boolean;
}

const HeaderCenterSection = ({ showTabs = true }: IHeaderCenterSection) => {
  const { globalState } = useGlobalContext();
  const { i18n } = useI18n();
  const location = useLocation();
  const isSuperAdmin = globalState.user.isSuperAdmin;
  const {
    BYBCAT_ACCESS,
    CUSTOM_PLAYLISTS,
    EDITOR_ACCESS
  } = useAuthorizations([
    AccountAuthorizations.BYBCAT_ACCESS,
    AccountAuthorizations.CUSTOM_PLAYLISTS,
    AccountAuthorizations.EDITOR_ACCESS,
  ]);

  // Filter routes based on authorizations
  const filteredRoutes = routeObjectList.filter((route) => {
    if (route.path === "/coach" && !(isSuperAdmin || (BYBCAT_ACCESS || CUSTOM_PLAYLISTS || EDITOR_ACCESS))) {
      return false;
    }
    if (route.path === "/playlists" && !(CUSTOM_PLAYLISTS || EDITOR_ACCESS)) {
      return false;
    }
    return true;
  });

  // Find current tab index in the filtered routes
  const getCurrentTabIndex = (pathname: string) => {
    const routeIndex = filteredRoutes.findIndex(route => route.path === pathname);
    return routeIndex >= 0 ? routeIndex : undefined;
  };

  const [currentTab, setCurrentTab] = useState(getCurrentTabIndex(location.pathname));

  const handleTabChange = (event: React.SyntheticEvent, newTabIndex: number) => {
    setCurrentTab(newTabIndex);
    Events.app.navigate.emit({ path: filteredRoutes[newTabIndex].path });
  };

  useEffect(() => {
    const path = location.pathname;
    setCurrentTab(getCurrentTabIndex(path));
  }, [location, filteredRoutes]);

  if (!showTabs) return null;

  return (
    <HeaderTabBar value={currentTab} onChange={handleTabChange}>
      {filteredRoutes.map((route, index) => (
        <HeaderTab key={route.path} label={i18n(route.label)} index={index} />
      ))}
    </HeaderTabBar>
  );
};

export default HeaderCenterSection;
